import React from 'react';
import { BsFillXCircleFill } from 'react-icons/bs';
import { Database } from '../../server/database';
import { checkNumber, getAssetImage } from '../util/util';
import './Modal.css'
import './GiftAssetModal.css'
import { Server } from '../../server/server';
import QuestionModal from './QuestionModal';
import MessageModal from './MessageModal';
import AlertModal from './AlertModal';
import { AppConfig } from '../AppConfig';

interface GiftAssetModalProps {
  open: boolean;
  friend: string;
  asset?: any;
  onClose: Function;
}

interface GiftAssetModalState {
  category: string;
  asset: any;
  quantity: string;
  question: string;
  message: string;
  alert: string;
}

class GiftAssetModal extends React.Component<GiftAssetModalProps, GiftAssetModalState> {
  constructor(props:GiftAssetModalProps) {
    super(props);

    this.state = {
      category: 'all',
      asset: this.props.asset ? this.props.asset : null,
      quantity: '1',
      question: '',
      message: '',
      alert: ''
    }

    this.onCategoryChange = this.onCategoryChange.bind(this);
    this.onQuantityChange = this.onQuantityChange.bind(this);
    this.onSelectAsset = this.onSelectAsset.bind(this);
    this.onCancelSend = this.onCancelSend.bind(this);
    this.onSend = this.onSend.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onQuestionYes = this.onQuestionYes.bind(this);
    this.onQuestionNo = this.onQuestionNo.bind(this);
    this.onAlertClose = this.onAlertClose.bind(this);
  }

  onCategoryChange(e: React.FormEvent<HTMLSelectElement>) {
    const element = e.target as HTMLSelectElement;
    this.setState({category: element.value});
  }

  onQuantityChange(e: React.FormEvent<HTMLInputElement>) {
    this.setState({quantity: e.currentTarget.value});
  }

  onSelectAsset(e:any) {
    this.setState({asset: e.target.parentElement.id})
  }

  onCancelSend() {
    this.setState({asset: null});
  }

  onSend() {
    let asset = Database.getAsset(this.state.asset);
    let friend = Server.public.getProfile(this.props.friend);
    let question = `Send ${this.state.quantity} ${asset.name} to ${friend.name}?`;
    this.setState({question: question});
  }

  onQuestionYes() {
    let quantity = checkNumber(this.state.quantity) ? +this.state.quantity : 0;

    if(quantity == 0) {
      this.setState({question: '', alert: 'Please enter a valid quantity.'});
      return;
    }

    if(Server.user.getAssetQuantity(this.state.asset) < quantity) {
      this.setState({question: '', alert: `You do not have ${quantity} to send.`});
      return;
    }

    this.setState({question: '', message: 'Sending gift...'});

    setTimeout(async () => {
      let response = null;
      if(this.state.asset == AppConfig.token.id)
        response = await Server.user.transferTokens(this.props.friend, quantity);
      else
        response = await Server.user.sendGift(this.props.friend, this.state.asset, quantity);

      if(response.success) 
        this.setState({message: '', alert: 'Gift sent!'});
      else
        this.setState({message: '', alert: response.message})
    }, 500);
  }

  onQuestionNo() {
    this.setState({question: ''})
  }

  onAlertClose() {
    this.setState({alert: '', asset: null});
    this.props.onClose(true);
  }

  onClose() {
    this.setState({asset: null});
    this.props.onClose(false);
  }

  renderAssetPanel(asset:any, marginRight:number = 0) {
    let src = getAssetImage(asset);
    let mrs = marginRight.toString() + 'px';
    return (
      <div key={asset.id} id={asset.id} className="gift-asset-modal-asset-panel" style={{marginRight: mrs}} onClick={this.onSelectAsset}>
        <img className="gift-asset-modal-asset-image" src={src} />
        <div style={{width: '100%', textAlign: 'left'}}>{asset.name}</div>
        <div style={{marginRight: '10px'}}>x{asset.quantity.toString()}</div>
      </div>
    )
  }

  renderSelectMode() {
    let assets = Server.user.getAssetsByCategory(this.state.category);

    let sortedAssets = [];
    for(let i = 0; i < assets.length; i++) {
      if(assets[i].category == 'banner' && Server.user.getBanner() == assets[i].id)
        continue;
      if(assets[i].category == 'portrait' && Server.user.getPortrait() == assets[i].id)
        continue;
      let asset = {...assets[i], ...Database.getAsset(assets[i].id)};
      sortedAssets.push(asset);
    }

    sortedAssets.sort((a, b)=>{
      if(a.quantity > b.quantity)
        return -1;
      else if(a.quantity < b.quantity)
        return 1;

      if(a.name < b.name)
        return -1;
      else if(a.name > b.name)
        return 1;

      return 0;
    })

    let panelMarginRight = sortedAssets.length >= 5 ? 10 : 0;

    let assetDivs = [];
    for(let i = 0; i < sortedAssets.length; i++) 
      assetDivs.push(this.renderAssetPanel(sortedAssets[i], panelMarginRight));

    return (
      <div>
        <select style={{width: '100%', marginBottom: '10px'}} value={this.state.category} onChange={this.onCategoryChange}>
          <option value="all">All</option>
          <option value="banner">Banner</option>
          <option value="collectible">Collectible</option>
          <option value="tokens">Currency</option>
          <option value="matcha">Matcha</option>
          <option value="portrait">Portraits</option>
          <option value="solitaire">Solitaire</option>
          <option value="whacka">Whacka</option>
        </select>
        {assetDivs.length > 0 ?
          <div className="gift-asset-modal-asset-container">
            {assetDivs}
          </div>
          :
          <div>No assets in this category.</div>
        }
      </div>
    )
  }

  renderQuantityMode() {
    let asset = {...Server.user.getAsset(this.state.asset), ...Database.getAsset(this.state.asset)};
    return (
      <div>
        {this.renderAssetPanel(asset)}
        <div className="gift-asset-modal-quantity-panel">
          <div style={{width: '100%', textAlign: 'left'}}>
            Quantity
          </div>
          <div style={{display: 'flex', alignItems: 'center'}}>
            x&nbsp;<input style={{width: '50px', textAlign: 'right'}} value={this.state.quantity} onChange={this.onQuantityChange}></input>
          </div>
        </div>
        <div style={{display: 'flex', justifyContent: 'space-between'}}>
          <button onClick={this.onCancelSend}>Cancel</button>
          <button onClick={this.onSend}>Send</button>
        </div>
      </div>
    )
  }

  render() {
    if(!this.props.open)
      return (<div></div>);

    if(this.state.question != '') 
      return (<QuestionModal message={this.state.question} onYes={this.onQuestionYes} onNo={this.onQuestionNo} />);

    if(this.state.alert != '') 
      return (<AlertModal message={this.state.alert} button="OK" onClose={this.onAlertClose}/>);

    if(this.state.message != '') 
      return (<MessageModal message={this.state.message} />);

    return (
      <div className="modal open">
        <div className="modal-content gift-asset-modal-content">
          <button className="modal-close-button" onClick={this.onClose}>
            <BsFillXCircleFill />
          </button>
          <div className="gift-asset-modal-header">Send Gift</div>
          {this.state.asset ? 
            this.renderQuantityMode() :
            this.renderSelectMode() 
          }
        </div>
      </div>
    );
  }
}

export default GiftAssetModal;
